import { render, staticRenderFns } from "./InfoCell.vue?vue&type=template&id=5b1517a6&"
import script from "./InfoCell.vue?vue&type=script&lang=js&"
export * from "./InfoCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports